module.exports = __webpack_public_path__ + "img/1.eb70b6eb.jpg";